/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'Wir setzen Cookies lediglich zur Nachverfolgung von Websitebesuchen ein. Wir speichern keine persönlichen Daten.',
    cookiesAccept: 'Cookies akzeptieren',
    cookiesDeny: 'Cookies ablehnen',
    tabFAQs: 'FAQs',
    tabSupport: 'Support',
    tabHistory: 'Geschichte',
    tabReviews: 'Geschichten',
    tabTraining: 'Schulung',
    tabUserTraining: 'Benutzertraining',
    tabHcpTraining: 'Gesundheitspersonaltraining',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Schwangerschaft',
    tabAbout: 'Über uns',
    tabNews: 'Neuigkeiten',
    tabCareers: 'Karriere',
    tabOrders: '',
    tabNotifications: 'Benachrichtigungen',
};

